import React, { useEffect, useState } from "react";
import { IoMdClose, IoMdAdd } from "react-icons/io";
import { Link } from 'react-router';
import { observer } from 'mobx-react';
import { languageStore } from '../../subscriber/Language';
import logo from "../../assets/LUCA_FINAL_LOGO.png";

const Header = observer(() => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    // const [openSubmenu, setOpenSubmenu] = useState(null);
    const { language, setLanguage, getPageTranslations } = languageStore;
    const t = getPageTranslations('menus');

    const languages = [
        { code: 'en', name: 'English' },
        { code: 'jp', name: '日本語' },
        { code: 'it', name: 'Italiano' },
        { code: 'es', name: 'Español' },
    ];
    useEffect(() => {
        if(!language) {
            setLanguage('en');
        }
    }, [language]);

    const menuStyle = "font-jost text-[17px] font-normal leading-none text-[#1f0707]";

    return (
        <header className="bg-[#fbe9dd] border-b border-[#5E0E0E2B] py-2.5 px-0 md:px-4 transition-all duration-300 ease-in-out mt-0 mb-0 z-20">
            <div className="max-w-6xl mx-auto flex items-center justify-between">
                {/* Logo */}
                <div className="ml-2 md:ml-0 w-1/4 md:w-1/4">
                    <Link to={`/`}>
                        <img
                            src={logo}
                            alt="Luca fantin"
                            width={170}
                            height={50}
                            className="w-[138px] md:w-[170px]"
                        />
                    </Link>
                </div>

                {/* Navigation */}
                <nav className="hidden md:block">
                    <ul className={`flex justify-between space-x-4 ${menuStyle}`}>
                        <li className="flex items-center">
                            <Link to={`/`} className="text-primary hover:text-[#C7702A] transition duration-300 px-4 py-2">
                                {t?.home}
                            </Link>
                        </li>
                        <li className="flex items-center">
                            <Link to={`/about_us`} className="text-primary hover:text-[#C7702A] transition duration-300 px-4 py-2 whitespace-nowrap">
                                {t?.about}
                            </Link>
                        </li>
                        <li className="flex items-center">
                            <Link to={`/blogs`} className="text-primary hover:text-[#C7702A] transition duration-300 px-4 py-2">
                                {t?.blog}
                            </Link>
                        </li>
                        <li className="flex items-center">
                            <Link to={`/projects`} className="text-primary hover:text-[#C7702A] transition duration-300 px-4 py-2">
                                {t?.projects}
                            </Link>
                        </li>
                        <li className="flex items-center">
                            <Link to={`/services`} className="text-primary hover:text-[#C7702A] transition duration-300 px-4 py-2">
                                {t?.services}
                            </Link>
                        </li>
                        <li className="flex items-center relative group">
                            <Link to="#" className="text-primary hover:text-[#C7702A] flex items-center transition duration-300 px-4 py-2">
                                {t?.pages}
                                <IoMdAdd className="ml-1 text-lg" />
                            </Link>
                            <div className="absolute left-0 top-full pt-2 hidden group-hover:block z-50">
                                <ul className="bg-white shadow-lg rounded-md py-2 w-48">
                                    {/* <li><Link to={`/menu`} className="block px-4 py-2 text-sm text-primary hover:text-[#C7702A] transition duration-300">Menu</Link></li>
                                    <li><Link to={`/pricing`} className="block px-4 py-2 text-sm text-primary hover:text-[#C7702A] transition duration-300">Pricing</Link></li>
                                    <li><Link to={`/faq`} className="block px-4 py-2 text-sm text-primary hover:text-[#C7702A] transition duration-300">FAQ</Link></li> */}
                                    <li><Link to={`/portfolio`} className="block px-4 py-2 text-sm text-primary hover:text-[#C7702A] transition duration-300">{t?.portfolio}</Link></li>
                                    <li><Link to={`/contact_us`} className="block px-4 py-2 text-sm text-primary hover:text-[#C7702A] transition duration-300">{t?.contactUs}</Link></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </nav>

                {/* Language Dropdown (hidden on mobile) */}
                <div className="md:block text-right">
                    <select
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                        className={`bg-[#d3752b] text-white px-4 py-2 rounded-md transition duration-300 appearance-none cursor-pointer ${menuStyle}`}
                        style={{
                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='rgb(31, 7, 7)' viewBox='0 0 24 24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
                            backgroundPosition: 'right 0.5rem center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '1.5em 1.5em',
                            paddingRight: '2.5rem',
                            border: "2px solid #d3752b",
                            outline: 'none',
                            color: "rgb(31, 7, 7)"
                        }}
                    >
                        {languages.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                                {lang.name}
                            </option>
                        ))}
                    </select>
                </div>
                
                {/* Mobile Menu Button (visible on mobile) */}
                <button 
                    className="md:hidden text-[#C7702A] text-3xl mr-2"
                    onClick={() => setIsMobileMenuOpen(true)}
                >
                    ☰
                </button>

            </div>

            {/* Mobile Menu Drawer */}
            <div 
                className={`fixed inset-y-0 left-0 w-3/4 bg-[#FFF] z-50 transition-all duration-300 ease-in-out transform ${
                    isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
                } ${menuStyle}`}
            >
                <div className="flex justify-between items-center p-4">
                    <img
                        src={logo}
                        alt="Luca fantin"
                        // width={150}
                        // height={60}
                        className="w-[150px]"
                    />
                    <button 
                        className="text-primary text-2xl"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        <IoMdClose />
                    </button>
                </div>
                <nav className="mt-8">
                    <ul className="space-y-4">
                        <li>
                            <Link to={`/`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4">
                                {t?.home}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/about_us`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4 whitespace-nowrap">
                                {t?.about}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/blogs`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4">
                                {t?.blog}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/projects`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4">
                                {t?.projects}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/services`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4">
                                {t?.services}
                            </Link>
                        </li>

                        <li>
                            <Link to={`/portfolio`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4">
                                {t?.portfolio}
                            </Link>
                        </li>
                        <li>
                            <Link to={`/contact_us`} className="text-primary text-lg hover:text-[#C7702A] transition duration-300 block px-4">
                                {t?.contactUs}
                            </Link>
                        </li>
                        {/* <li>
                            <div 
                                className="flex justify-between items-center block hover:text-[#C7702A] transition duration-300 px-4 cursor-pointer text-lg"
                                onClick={() => setOpenSubmenu(openSubmenu === 'pages' ? null : 'pages')}
                            >
                                <span>{t?.pages}</span>
                                <IoMdAdd className="text-lg" />
                            </div>
                            {openSubmenu === 'pages' && (
                                <ul className="ml-4 mt-2 space-y-2">
                                    <li><Link to={`/menu`} className="text-white hover:text-[#C7702A] transition duration-300 block px-4">Menu</Link></li>
                                    <li><Link to={`/pricing`} className="text-white hover:text-[#C7702A] transition duration-300 block px-4">Pricing</Link></li>
                                    <li><Link to={`/faq`} className="text-white hover:text-[#C7702A] transition duration-300 block px-4">FAQ</Link></li>
                                    <li><Link to={`/portfolio`} className="block text-lg hover:text-[#C7702A] transition duration-300 block px-4">{t?.portfolio}</Link></li>
                                    <li><Link to={`/contact_us`} className="block text-lg hover:text-[#C7702A] transition duration-300 block px-4">{t?.contactUs}</Link></li>
                                </ul>
                            )}
                        </li> */}
                        <li className="ml-1">
                            <select
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                                className={`bg-[#d3752b] text-white px-4 py-2 rounded-md transition duration-300 appearance-none cursor-pointer ${menuStyle}`}
                                style={{
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='rgb(31, 7, 7)' viewBox='0 0 24 24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
                                    backgroundPosition: 'right 0.5rem center',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: '1.5em 1.5em',
                                    paddingRight: '2.5rem',
                                    border: "2px solid #d3752b",
                                    outline: 'none',
                                    color: "rgb(31, 7, 7)"
                                }}
                            >
                                {languages.map((lang) => (
                                    <option key={lang.code} value={lang.code}>
                                        {lang.name}
                                    </option>
                                ))}
                            </select>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
});

export default Header;
